var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Arrival Date On Dock","chart":"column","chartType":"arrivalDate","isCity":false,"withDate":true,"withFinancial":false,"arrivalDate":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }